import { useState } from 'react';
import { useDeviceStore } from '@namespace/device';
import { useLocation } from '@namespace/i18n';
import { useHistory, useSearchParams } from '@namespace/router';
import { GAMES_LIST_PAGE_SIZE, IS_USE_PLEX_API } from '../../constants';
import { usePlexCategoryInSearchPagination } from '../../hooks/usePlexCasinoGamesSectionPagination';
import { useGetLobbyCategoryGames } from '../../store';

const useBottomCategoryGamesListPlex = ({
  casinoSearchBottomCategoryName,
  casinoType
}) => {
  const [page, setPage] = useState(1);
  const { isDesktop } = useDeviceStore();
  const {
    handlePageChange,
    games: bottomCategoryGames,
    ...restCategoryPagination
  } = usePlexCategoryInSearchPagination({
    casinoType,
    category: casinoSearchBottomCategoryName,
    pageSize: GAMES_LIST_PAGE_SIZE,
    ...(isDesktop ? { page } : {})
  });

  const handlePageChangeModified = (newPage) => {
    if (isDesktop) {
      setPage(newPage);
    }
    handlePageChange(newPage);
  };

  return {
    ...restCategoryPagination,
    handlePageChange: handlePageChangeModified,
    bottomCategoryGames
  };
};

const useBottomCategoryGamesListNonPlex = ({
  casinoSearchBottomCategoryName,
  feedName,
  casinoType
}) => {
  const bottomCategoryGames = useGetLobbyCategoryGames(
    casinoSearchBottomCategoryName,
    feedName,
    casinoType
  );

  const { query } = useSearchParams();
  const { pathname } = useLocation();
  const { replace } = useHistory();

  const handlePageChange = (newPage) =>
    replace(`${pathname}?page=${newPage}&query=${query}`);

  const { page } = useSearchParams();

  const formattedPageFromUrl = page ? Number(page) : 1;

  return { bottomCategoryGames, handlePageChange, page: formattedPageFromUrl };
};

export const useBottomCategoryGamesList = IS_USE_PLEX_API
  ? useBottomCategoryGamesListPlex
  : useBottomCategoryGamesListNonPlex;
